<template>
  <v-card>
    <v-card-title>
      {{ $t('signComponent.title') }}
    </v-card-title>
    <v-card-text>
      <v-select
          :label="$t('signComponent.selectLabel')"
          :items="certificateDropdownOptions"
          v-model="certificate"
      >
        <template v-slot:no-data>
          <h5 class="text-center">{{ $t('signComponent.noKeys') }}</h5>
        </template>

        <template v-slot:item="{item}">
          <v-card flat width="100%" class="mb-2">
            <v-card-text class="pa-0">
              <div class="subtitle-1">
                <span class="font-weight-light">{{ $t('signComponent.itemLabels.owner') }}</span> <span
                  class="font-weight-bold float-right">{{ item.value.issuedPerson.toUpperCase() }}</span><br>
                <span class="font-weight-light">{{ $t('signComponent.itemLabels.organization') }}</span> <span
                  class="font-weight-bold float-right">{{ item.text.toUpperCase() }}</span> <br>
                <span class="font-weight-light">{{ $t('signComponent.itemLabels.tin') }}</span> <span class="font-weight-bold float-right">{{ item.value.innNumber }}</span>
                <br>
                <span class="font-weight-light">{{ $t('signComponent.itemLabels.validUntil') }}</span> <span
                  class="font-weight-bold float-right">{{ item.value.validEndDate.toLocaleDateString() }}</span>
              </div>
            </v-card-text>

            <v-divider class="my-1" color="yellow"/>
          </v-card>
        </template>
      </v-select>
    </v-card-text>

    <v-card-actions>
      <v-btn color="primary" @click="onCancel" :disabled="disable">{{ $t('common.actions.cancel') }}</v-btn>
      <v-spacer/>
      <v-btn color="primary" :disabled="$v.$invalid || disable" @click="onSignClicked">{{ $t('signComponent.actions.sign') }}</v-btn>
    </v-card-actions>

    <v-snackbar v-model="isSignFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      {{ $t('signComponent.messages.signError') }}
    </v-snackbar>
  </v-card>
</template>

<script>
import EImzo from '../plugins/eimzo'
import _ from 'underscore'
import {required} from 'vuelidate/lib/validators'

export default {
  name: "SignComponent",
  props: {
    hashCode: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      certificate: null,
      isSignFailed: false
    }
  },
  validations: {
    certificate: {
      required
    }
  },
  computed: {
    // certificate: {
    //   get() {
    //     return this.$store.getters.certificate
    //   },
    //   set(data) {
    //     this.$store.commit('setCertificate', data)
    //   }
    // },
    certificates() {
      return EImzo.certificates;
    },
    activeCertificates() {
      const nowTime = (new Date()).getTime();

      return _.filter(this.certificates, certificate => {
        const certificateEndTime = certificate.validEndDate.getTime();

        return certificateEndTime > nowTime;
      });
    },
    certificateDropdownOptions() {
      return _.map(this.activeCertificates, activeCertificate => {
        return {
          text: activeCertificate.companyName || activeCertificate.issuedPerson,
          value: activeCertificate
        };
      });
    }
  },
  methods: {
    onSignClicked() {
      this.isSignFailed = false
      EImzo.activateCertificate(this.certificate)
          .then(activatedCertificate => {
            // this.$store.commit('setCertificate', activatedCertificate)

            EImzo.createPkcs7(this.hashCode, activatedCertificate)
                .then(signResult => {
                  this.$emit('sign', signResult)
                }, () => {
                  this.isSignFailed = true
                })
          }, () => {
            this.isSignFailed = true
          })
    },
    onCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>